import type { FaireProductEntity } from "../../entity_types/product";

export const p_5e4mgthvp6: FaireProductEntity = {
  token: "p_5e4mgthvp6",
  type: "product",
  name: "Enamel Gold-Plated Evil Eye Ring",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/f90966bb270d382ac056fe90e9ee160f0953a03d5b38a993acc665af22de5ea6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/515575a66642843eefe717811bef16a5b39fdbc15c33ac08fa602211f4c951bc.jpeg",
    "https://cdn.faire.com/fastly/ee7f05fb7485c0bdd207890d6d252f5c59cfa9a6f48025c089aa03075e85e410.jpeg",
    "https://cdn.faire.com/fastly/b8d672ebd57616b77851f953451b7bf835b57de9fd445806dc1bc0dc6343080f.jpeg",
    "https://cdn.faire.com/fastly/1b1a936f03b612ee8b4c8f8f2009747268663c3ccc58eeae12aa757a99c8ed77.jpeg",
    "https://cdn.faire.com/fastly/c11e0e01d7c793f09ac31ae753ea7a661a24225a8484acb6df8e8baa2439b94c.jpeg",
    "https://cdn.faire.com/fastly/746bdd75d13d8cc8b3200666064be1525fe3d8f682036af1b3321e9f4a9af504.jpeg",
    "https://cdn.faire.com/fastly/c47688361aeeeed864a5992d7b6e1c104c01d0f1c268a12d25eb927025c10ec1.jpeg",
    "https://cdn.faire.com/fastly/37808de57842d0492edef0519a16b192c0210381823609227d72406a276974cb.jpeg",
    "https://cdn.faire.com/fastly/67ea97323cd5c46d9d39c70c317f126b459da3a4c0f4435ea42fecbbcba08c9c.jpeg",
  ],
  priceDollars: 3.77,
  description:
    "\nA captivating piece featuring a unique design with the devil's eye motif in vibrant enamel colors on a gold-plated setting. \n\nThe mysterious eye pattern creates a visually striking effect. \n\nThe enamel colors stand out against the golden background, adding an intriguing touch to the ring. \n\nThis enchanting accessory showcases individuality and a contemporary style, making it a standout choice for those who appreciate unique and attention-grabbing jewelry.\n\nMaterial: copper, enamel, gold plated\n\nSize: 8mm wide, adjustable opening\n\n",
  tags: [],
  msrpDollars: 9.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:00.128Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
